import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'

import { Waypoint } from 'react-waypoint'
import BackgroundBlobAnimation from './BackgroundBlobAnimation'
import Answer from 'components/Answer'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [hasEntered, setHasEntered] = useState(false)
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {properties?.eingabe && (
        <Waypoint
          scrollableAncestor={window}
          onEnter={() => {
            setTimeout(() => {
              setHasEntered(true)
            }, 500)
          }}
        >
          <div>
            <TextWidth>
              <Wrapper hasEntered={hasEntered}>
                <Prompt>{properties?.eingabe}</Prompt>
                {properties?.ausgabe && (
                  <Answer answerText={properties?.ausgabe} gptBadge='GPT-3' />
                )}
                {properties?.ausgabeGpt4 && (
                  <Answer
                    answerText={properties?.ausgabeGpt4}
                    gptBadge='GPT-4'
                  />
                )}
                {/* { Number(properties?.gptModel) === 4 && <BackgroundBlobAnimation />} */}
              </Wrapper>
            </TextWidth>
          </div>
        </Waypoint>
      )}
    </AppContainer>
  )
}
const Wrapper = styled.div<{ hasEntered?: boolean }>`
  // make it skeomorphic
  position: relative;
  font-family: var(--font-sans-serif);
  background: var(--modal-background);
  border-radius: 0.5em;
  padding: 1em;
  margin-bottom: 1em;
  box-shadow: 0 ${({ hasEntered }) => (hasEntered ? '10px 20px' : '0 0')}
    rgba(0, 0, 0, 0.09);
  // box-shadow animation
  transition: all 0.9s ease-in-out;
  overflow: hidden;
`
const Prompt = styled.h4`
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0.5em;
`

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  .content {
    @media (max-width: 500px) {
      padding-left: 0;
      padding-right: 0;
    }
  }
`
export default MainComponent
